import { render } from "./CalendarView.vue?vue&type=template&id=0b562734"
import script from "./CalendarView.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./CalendarView.vue?vue&type=script&charset=utf-8&lang=js"

import "./CalendarView.vue?vue&type=style&index=0&id=0b562734&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__